import { useSyncExternalStore } from "react";
import { isNative } from "../native.js";
import { isSyncing, offlineStore, subscribeOfflineStore, subscribeSyncing } from "./index.js";
import type { OfflineStore } from "./store.js";

const noSubscription = () => () => {};

/**
 * spec11: the open offline store, re-rendering on every change in it. Null in the browser,
 * so callers can branch on it.
 */
export function useOfflineStore(): OfflineStore | null {
  const store = useSyncExternalStore(
    isNative ? subscribeOfflineStore : noSubscription,
    () => (isNative ? offlineStore() : null),
    () => null,
  );
  useSyncExternalStore(
    store ? store.subscribe : noSubscription,
    () => store?.version() ?? 0,
    () => 0,
  );
  return store;
}

/** "Syncing…" while a sync runs (FR12). */
export function useSyncing(): boolean {
  return useSyncExternalStore(isNative ? subscribeSyncing : noSubscription, isSyncing, () => false);
}
